import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'The Jira workflow status of a requirement: To Do, In Progress, In Review, Done, or Unknown',
    name: 'Jira Status',
    partialId: PartialId.Standard.create('jira_status'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
